module.exports = __webpack_public_path__ + "img/page_bg.4925d3d8.png";